export default "__VITE_ASSET__b742455f__"